









import { Component, Prop, Vue } from "vue-property-decorator";

const CollapsedButton = require("@/assets/chevron-right.png");
const ExpandedButton = require("@/assets/chevron-left.png");

@Component({})
export default class SidebarToggleButton extends Vue {
  @Prop({ type: Boolean }) collapsed!: boolean;

  get src() {
    return this.collapsed ? CollapsedButton : ExpandedButton;
  }
}
